import React from "react";
import { HStack, Text, Box } from "@chakra-ui/react";

const LabeledText = ({ label, text }) => {
  return (
    <HStack fontSize={"0.8rem"}>
      <Text
        textTransform="uppercase"
        pr="1"
        width={["80%", "45%"]}
        noOfLines={2}
      >
        {label + ":"}
      </Text>
      <Box fontSize="1em" w="100%" color="black">
        {text}
      </Box>
    </HStack>
  );
};

export default LabeledText;
